module.exports = __webpack_public_path__ + "img/car-marker.5eab98c0.svg";